import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.span`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #3d3d3d;
`;

export const SubTitle = styled.span`
  display: inline-block;
  margin-top: 12px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #3d3d3d;
`;

export const ImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
`;

export const Img = styled.img`
  max-width: 302px;
  max-height: 352px;
  border-radius: 8px;
`;

export const ButtonOK = styled.button`
  margin-top: 24px;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #0b29fb;
  background: transparent;

  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #0b29fb;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ed9500;
  border-radius: 8px;
  background: #fff8ec;
  padding: 16px 24px;
  gap: 24px;
`;

export const CardInfoIcon = styled.div``;

export const CardInfoText = styled.span`
  display: inline-block;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #ed9500;
`;
